
interface standardOrderType {
    PDAS_Id, 
    calculateWithCar,
    calculateWithTruck, 
    isPdasWalletApplied,
    isPhlenuCashApplied,
    isPromoCodeApplied,
    // conveniencePercentage,
    damageCoverPercentage,
    isConvenienceApply,
    tipAmount,
    promoUpdate,
    tipId,
    userId,
    isSchedule,
    isTipGiven, 
    // totalCashCollected,
    changeStatus : number, 
   
    
    uniqueId,
    region,
    time,
    createdAt
    promoTitle : string,


    deliveryCharges : Array<[]>, 

    selectedAddress,promoResponse : object
}


export let standardOrderModel:standardOrderType = {
    PDAS_Id : 0,
    calculateWithCar : 0,
    calculateWithTruck : 0,
    changeStatus : 0,
    // conveniencePercentage : 0,
    createdAt : '',
    damageCoverPercentage : 0,
    deliveryCharges : [],
    isConvenienceApply  : 0,
    isPdasWalletApplied : 0,
    isPhlenuCashApplied : 0,
    isPromoCodeApplied : 0,
    isTipGiven : 0,
    promoResponse : {},
    isSchedule : 0,

    promoTitle : '',
    promoUpdate : 0,
    region : '',
    selectedAddress : {from:[], to :[]},
    time : '',
    tipAmount : 0,
    tipId : 0,
    // totalCashCollected : 0,
    uniqueId : '',
    userId : 0
}